export default function() {
	var waypoint = new Waypoint({
		element: document.getElementById('main'),
		handler: function(direction) {
			if ( direction === 'down' ) {
				document.getElementsByTagName('body')[0].classList.add('has-scrolled');
			} else if ( direction === 'up' ) {
				document.getElementsByTagName('body')[0].classList.remove('has-scrolled');
			}
 		},
		offset: '-10%'
	})
}
